import { render, staticRenderFns } from "./EditStyleBorderRadius.vue?vue&type=template&id=aef8fa88&scoped=true&"
import script from "./EditStyleBorderRadius.vue?vue&type=script&lang=js&"
export * from "./EditStyleBorderRadius.vue?vue&type=script&lang=js&"
import style0 from "./EditStyleBorderRadius.vue?vue&type=style&index=0&id=aef8fa88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef8fa88",
  null
  
)

export default component.exports